import App_Phone_1 from "../../../common/images/app_phone1.png";
import App_Phone_2 from "../../../common/images/appstore_capture.png";
import App_Phone_3 from "../../../common/images/app_phone3.png";
import App_Phone_List from "../../../common/images/App_Phone_List.png";

const IntroduceApp = () => {
  return (
    <div className="flex flex-col space-y-[60px]">
      {/* section 1 */}
      <section
        x-data="{activeItem: 1}"
        className="pb-20 pt-20 dark:bg-dark lg:pb-[120px] lg:pt-[120px]"
      >
        <div className="container mx-auto">
          <div className="-mx-4 flex flex-wrap justify-center">
            <div className="w-full px-4">
              <div className="mx-auto max-w-[510px] text-center ">
                <span className="mb-2 block text-2xl font-semibold text-primary text-brand100">
                  반려동물 네 발자국, 우리의 두 발자국
                </span>
                <h2 className="mb-3 text-3xl font-bold leading-[1.2] text-dark dark:text-white sm:text-4xl md:text-[40px]">
                  식스스탭 어플리케이션 출시
                </h2>
                <p className="text-2xl text-body-color dark:text-dark-6 sm:mt-[40px]">
                  구글 플레이스토어에 '식스스탭'을 검색하면
                  <br /> 기부 NFT 서비스를 모바일로도 이용할 수 있습니다.
                </p>
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-center">
            <img src={App_Phone_List} />
          </div>
        </div>
      </section>
      {/* section 2*/}
      <section className="dark:bg-dark">
        <div className="container mx-auto">
          <div className="relative z-10 overflow-hidden rounded bg-[#eed9c5] bg-opacity-75 dark:bg-dark-3">
            <div className="-mx-4 flex flex-wrap">
              <div className="w-full px-4 lg:w-1/2">
                <div className="px-6 py-14 sm:px-10 md:px-[70px] md:py-20 lg:pl-11 lg:pr-0">
                  <h2 className="mb-9 text-2xl font-bold leading-snug text-brand100 dark:text-white md:text-[40px]/[48px]">
                    Download our application from the Play Store!
                  </h2>
                  <h3 className="text-lg mb-2 font-semibold text-[#600B0A]">
                    세계 최초 유기동물 기부 NFT 마켓플레이스
                  </h3>
                  <p className="mb-11 text-3xl font-semibold text-body-color dark:text-dark-6">
                    식스스탭 서비스를
                    <br />
                    Play Store 에서 만나보세요
                  </p>
                  <div className="flex flex-wrap items-center">
                    <a className="my-1 mr-4 inline-flex h-[70px] items-center justify-center rounded-lg bg-[#600B0A] px-5 text-center text-base font-medium text-dark shadow-[0px_5px_18px_0px_rgba(0,0,0,0.08)] transition duration-200 hover:text-primary dark:bg-dark-2 dark:text-white sm:px-6 md:text-lg">
                      <span className="mr-1 flex h-11 w-11 items-center justify-center rounded-md bg-dark dark:bg-white/10">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.85245 0.375L14.0977 10.6184L16.7415 7.9746C13.1289 5.78276 8.29042 2.84244 6.11441 1.52043L4.65656 0.637253C4.3989 0.480274 4.12297 0.395734 3.85245 0.375ZM2.28856 1.60143C2.26783 1.71398 2.25 1.82709 2.25 1.94853V22.1922C2.25 22.2771 2.26708 22.3562 2.27892 22.4372L12.7016 12.0145L2.28856 1.60143ZM18.4789 9.0294L15.4938 12.0145L18.4269 14.9475C19.9809 14.0056 21.0572 13.3515 21.1767 13.2795C21.7049 12.9566 22.0032 12.4695 21.9943 11.9373C21.9864 11.415 21.688 10.9481 21.1805 10.6608C21.067 10.5956 20.0053 9.95449 18.4789 9.0294ZM14.0977 13.4106L3.88331 23.625C4.08176 23.5905 4.27995 23.5312 4.46951 23.4167C4.73216 23.2568 11.8269 18.9523 16.6894 16.0023L14.0977 13.4106Z"
                            fill="#f5cbac"
                          ></path>
                        </svg>
                      </span>
                      <span
                        className="text-2xl text-[#f5cbac] font-semibold cursor-pointer"
                        onClick={() => {
                          window.open(
                            " https://play.google.com/store/apps/details?id=com.whatcon.sixsteps&hl=ko-KR"
                          );
                        }}
                      >
                        플레이 스토어
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full self-end px-4 lg:w-1/2">
                <div className="hidden text-center lg:block">
                  <img
                    src={App_Phone_1}
                    alt="image"
                    className="mx-auto max-w-full"
                  />
                </div>
              </div>
            </div>

            <div className="hidden md:block">
              <span className="absolute right-0 top-0 z-[-1]">
                <svg
                  width="329"
                  height="218"
                  viewBox="0 0 329 218"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="182" cy="36" r="182" fill="#600A0A"></circle>
                </svg>
              </span>
              <span className="absolute right-0 top-20 z-[-1]">
                <svg
                  width="95"
                  height="161"
                  viewBox="0 0 95 161"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="80.5" cy="80.5" r="80.5" fill="#E7A35C"></circle>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* section 3*/}
      <section className="bg-white pb-8 pt-20 dark:bg-dark lg:pb-10 lg:pt-[10%] ">
        <div className="container mx-auto">
          <div className="-mx-4 mb-10 flex flex-wrap items-center lg:mb-[60px]">
            <div className="w-full px-4 lg:w-6/12">
              <div className="flex justify-center">
                <img
                  src={App_Phone_3}
                  alt="image"
                  className="mx-auto max-w-full"
                />
              </div>
            </div>
            <div className="w-full px-4 lg:w-6/12">
              <div className="mb-[60px] max-w-[500px] xl:mb-[70px]">
                <span className="mb-2 block text-lg font-semibold text-primary">
                  식스스탭 모바일 앱
                </span>
                <h2 className="text-3xl font-bold text-brand100 dark:text-white sm:text-4xl md:text-[40px]">
                  All You Need to Know About The App
                </h2>
              </div>
              <div className="-mx-4 flex flex-wrap">
                <div className="w-full px-4 sm:w-1/2">
                  <div className="mb-10">
                    <div className="mb-6 flex h-[75px] w-[75px] items-center justify-center rounded-[20px] bg-[#4BA0FF] text-white">
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        className="fill-current"
                      >
                        <path d="M25.6484 10.8826V9.13259C25.6484 4.75759 22.3672 1.09353 18.2109 0.710713C15.9141 0.491963 13.6172 1.31228 11.9219 2.84353C10.2813 4.37478 9.29688 6.50759 9.29688 8.74978V10.8279C6.01563 11.3201 3.55469 14.1638 3.55469 17.5545V27.8904C3.55469 31.4451 6.45312 34.3435 10.0078 34.3435H24.9375C28.4922 34.3435 31.3906 31.4451 31.3906 27.8904V17.4998C31.4453 14.1638 28.9297 11.4295 25.6484 10.8826ZM13.2344 4.2654C14.5469 3.06228 16.2422 2.46071 18.0469 2.62478C21.2188 2.89821 23.7344 5.74196 23.7344 9.13259V10.7732H11.2656V8.74978C11.2656 7.05446 11.9766 5.41384 13.2344 4.2654ZM29.5313 27.8357C29.5313 30.3513 27.5078 32.3748 24.9922 32.3748H10.0078C7.49219 32.3748 5.46875 30.3513 5.46875 27.8357V17.6092C5.46875 14.9295 7.65625 12.6873 10.3906 12.6873H24.5547C27.2891 12.6873 29.5313 14.8201 29.5313 17.4998V27.8357Z"></path>
                        <path d="M17.5 19.4141C16.9531 19.4141 16.5156 19.8516 16.5156 20.3984V21.8203V23.2422V26.1406C16.5156 26.6875 16.9531 27.125 17.5 27.125C18.0469 27.125 18.4844 26.6875 18.4844 26.1406V23.2422V21.8203V20.3984C18.4844 19.8516 18.0469 19.4141 17.5 19.4141Z"></path>
                      </svg>
                    </div>
                    <h3 className="mb-3 text-xl font-semibold text-dark dark:text-white 2xl:text-[22px]">
                      Block Chain
                    </h3>
                    <p className="text-base leading-relaxed text-body-color dark:text-dark-6">
                      블록체인 기술을 통해 거래의 투명성을 제공하며, 고유한
                      식별자로 유기동물의 이력을 관리합니다.
                    </p>
                  </div>
                </div>
                <div className="w-full px-4 sm:w-1/2">
                  <div className="mb-10">
                    <div className="mb-6 flex h-[75px] w-[75px] items-center justify-center rounded-[20px] bg-[#FBD06F] text-white">
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        className="fill-current"
                      >
                        <path d="M29.0391 21.1094V14.3828C29.0391 14.3281 29.0391 14.2734 29.0391 14.2187V7.38281C29.0391 3.60937 24.0078 0.65625 17.5547 0.65625C11.1016 0.65625 6.01562 3.66406 6.01562 7.38281V14.1641C6.01562 14.2187 6.01562 14.3281 6.01562 14.3828V21.1094C6.01562 21.1641 6.01562 21.2187 6.01562 21.2734V27.6172C6.01562 31.3359 11.1562 34.3437 17.5 34.3437C23.8438 34.3437 28.9844 31.3359 28.9844 27.6172V21.2734C28.9844 21.2187 29.0391 21.1641 29.0391 21.1094ZM8.36719 18.2109C10.5 19.7969 13.9453 20.7266 17.5 20.7266C21.1641 20.7266 24.5 19.7969 26.6328 18.2109C26.7969 18.1016 26.9609 17.9922 27.0703 17.8281V21.2187C26.9062 23.4062 23.0781 25.7031 17.5 25.7031C11.8672 25.7031 8.03906 23.4062 7.92969 21.1641V17.7734C8.03906 17.9922 8.20312 18.1016 8.36719 18.2109ZM7.92969 14.3281V11.1562C9.95312 12.9609 13.4531 14.1094 17.5 14.1094C21.5469 14.1094 25.0469 12.9609 27.0703 11.1562V14.2734C27.0156 15.3125 26.1953 16.1328 25.4844 16.625C23.6797 17.9922 20.7266 18.7578 17.5 18.7578C14.3281 18.7578 11.3203 17.9375 9.51562 16.625C8.80469 16.1875 7.98438 15.3672 7.92969 14.3281ZM17.5 2.625C22.6953 2.625 27.0703 4.8125 27.0703 7.4375C27.0703 10.0625 22.6953 12.25 17.5 12.25C12.3047 12.25 7.92969 10.0625 7.92969 7.4375C7.92969 4.8125 12.3047 2.625 17.5 2.625ZM17.5 32.4297C11.8672 32.4297 7.92969 29.9141 7.92969 27.6172V24.8281C9.95312 26.5781 13.4531 27.7266 17.5 27.7266C21.5469 27.7266 25.0469 26.5781 27.0703 24.8281V27.6172C27.0703 29.8594 23.1328 32.4297 17.5 32.4297Z"></path>
                      </svg>
                    </div>
                    <h3 className="mb-3 text-xl font-semibold text-dark dark:text-white 2xl:text-[22px]">
                      Backup Database
                    </h3>
                    <p className="text-base leading-relaxed text-body-color dark:text-dark-6">
                      데이터의 추가적인 보안 및 백업이 이루어져 더욱 안전하게
                      데이터를 관리합니다.
                    </p>
                  </div>
                </div>
                <div className="w-full px-4 sm:w-1/2">
                  <div className="mb-10">
                    <div className="mb-6 flex h-[75px] w-[75px] items-center justify-center rounded-[20px] bg-[#A097FF] text-white">
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        className="fill-current"
                      >
                        <path d="M29.5312 21.656L28.6563 21.1638L29.6953 20.5623C30.7344 19.906 31.3359 18.8123 31.2812 17.6091C31.2266 16.406 30.625 15.3123 29.5312 14.7107L27.8906 13.781L29.6406 12.6873C30.6797 12.031 31.2812 10.9373 31.2266 9.73413C31.1719 8.53101 30.5703 7.43726 29.4766 6.83569L19.25 1.09351C18.2109 0.491943 16.9531 0.546631 15.9141 1.09351L5.41406 7.21851C4.375 7.82007 3.71875 8.91382 3.71875 10.1169C3.71875 11.3201 4.375 12.4138 5.41406 13.0154L7.10938 13.9998L5.41406 14.9841C4.375 15.5857 3.71875 16.6794 3.71875 17.8826C3.71875 19.0857 4.32031 20.1794 5.41406 20.781L6.39844 21.3279L5.46875 21.8748C4.42969 22.4763 3.77344 23.5701 3.77344 24.7732C3.77344 25.9763 4.375 27.0701 5.46875 27.6716L15.9141 33.6873C16.4609 34.0154 17.0078 34.1248 17.6094 34.1248C18.2109 34.1248 18.8125 33.9607 19.3594 33.6326L29.6953 27.2888C30.7344 26.6326 31.3359 25.5388 31.2812 24.3357C31.2266 23.2966 30.625 22.2029 29.5312 21.656ZM5.63281 10.1169C5.63281 9.57007 5.90625 9.13257 6.34375 8.85913L16.8438 2.78882C17.0625 2.67944 17.3359 2.57007 17.5547 2.57007C17.7734 2.57007 18.0469 2.62476 18.2656 2.73413L28.5469 8.47632C28.9844 8.74976 29.2578 9.18726 29.3125 9.73413C29.3125 10.281 29.0391 10.7185 28.6016 10.9919L18.3203 17.3904C17.8828 17.6638 17.2812 17.6638 16.8438 17.3904L6.39844 11.3748C5.90625 11.156 5.63281 10.6638 5.63281 10.1169ZM5.63281 17.9373C5.63281 17.3904 5.90625 16.9529 6.34375 16.6794L9.02344 15.1482L15.8594 19.0857C16.4062 19.4138 16.9531 19.5232 17.5547 19.5232C18.1562 19.5232 18.7578 19.3591 19.3047 19.031L26.0312 14.8748L28.6016 16.2966C29.0391 16.5701 29.3125 17.0076 29.3672 17.5544C29.3672 18.1013 29.0938 18.5388 28.6563 18.8123L18.3203 25.2654C17.8828 25.5388 17.2812 25.5388 16.8438 25.2654L6.39844 19.2498C5.90625 18.9763 5.63281 18.4841 5.63281 17.9373ZM28.6563 25.8123L18.3203 32.2107C17.8828 32.4841 17.2812 32.4841 16.8438 32.2107L6.39844 26.1951C5.96094 25.9216 5.6875 25.4841 5.6875 24.9373C5.6875 24.3904 5.96094 23.9529 6.39844 23.6794L8.3125 22.5857L15.8594 26.9607C16.4062 27.2888 16.9531 27.3982 17.5547 27.3982C18.1562 27.3982 18.7578 27.2341 19.3047 26.906L26.7969 22.2576L28.6563 23.2966C29.0938 23.5701 29.3672 24.0076 29.4219 24.5544C29.3672 25.0466 29.0938 25.5388 28.6563 25.8123Z"></path>
                      </svg>
                    </div>
                    <h3 className="mb-3 text-xl font-semibold text-dark dark:text-white 2xl:text-[22px]">
                      Various Networks
                    </h3>
                    <p className="text-base leading-relaxed text-body-color dark:text-dark-6">
                      다양한 블록체인 네트워크를 지원합니다.
                    </p>
                  </div>
                </div>
                <div className="w-full px-4 sm:w-1/2">
                  <div className="mb-10">
                    <div className="mb-6 flex h-[75px] w-[75px] items-center justify-center rounded-[20px] bg-[#48DB7A] text-white">
                      <svg
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        className="fill-current"
                      >
                        <path d="M30.2969 23.7344H26.3594C24.5547 23.7344 22.9687 24.9375 22.4766 26.6328H10.3359C8.09375 26.6328 6.23437 24.7734 6.23437 22.5312C6.23437 20.2891 8.09375 18.4297 10.3359 18.4297H24.6641C28 18.4297 30.6797 15.75 30.6797 12.4141C30.6797 9.07813 28 6.39844 24.6641 6.39844H12.6875V6.125C12.6875 3.88281 10.8828 2.07812 8.64062 2.07812H4.70312C2.46094 2.07812 0.65625 3.88281 0.65625 6.125V7.16406C0.65625 9.40625 2.46094 11.2109 4.70312 11.2109H8.64062C10.4453 11.2109 12.0312 10.0078 12.5234 8.3125H24.6641C26.9062 8.3125 28.7656 10.1719 28.7656 12.4141C28.7656 14.6563 26.9062 16.5156 24.6641 16.5156H10.3359C7 16.5156 4.32031 19.1953 4.32031 22.5312C4.32031 25.8672 7 28.5469 10.3359 28.5469H22.3125V28.8203C22.3125 31.0625 24.1172 32.8672 26.3594 32.8672H30.2969C32.5391 32.8672 34.3437 31.0625 34.3437 28.8203V27.7812C34.3437 25.5391 32.4844 23.7344 30.2969 23.7344ZM10.7734 7.21875C10.7734 8.36719 9.84375 9.35156 8.64062 9.35156H4.70312C3.55469 9.35156 2.57031 8.42188 2.57031 7.21875V6.17969C2.57031 5.03125 3.5 4.04688 4.70312 4.04688H8.64062C9.78906 4.04688 10.7734 4.97656 10.7734 6.17969V7.21875ZM32.4297 28.8203C32.4297 29.9688 31.5 30.9531 30.2969 30.9531H26.3594C25.2109 30.9531 24.2266 30.0234 24.2266 28.8203V27.7812C24.2266 26.6328 25.1562 25.6484 26.3594 25.6484H30.2969C31.4453 25.6484 32.4297 26.5781 32.4297 27.7812V28.8203Z"></path>
                      </svg>
                    </div>
                    <h3 className="mb-3 text-xl font-semibold text-dark dark:text-white 2xl:text-[22px]">
                      Entire Adoption Process
                    </h3>
                    <p className="text-base leading-relaxed text-body-color dark:text-dark-6">
                      구조, 등록, 생활, 진료, 입양 NFT를 통해 <br />
                      전주기 프로세스를 관리합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* section 4*/}
      <div className="relative z-10 overflow-hidden bg-white pb-[110px] pt-[120px] dark:bg-dark md:pt-[150px] lg:pt-[140px]">
        <div className="absolute left-0 top-0 z-[-1] h-full w-full rounded-br-[200px] bg-[#E06611] dark:bg-dark-2 lg:w-1/2"></div>
        <div className="container mx-auto ml-5">
          <div className="-mx-4 flex flex-wrap items-center">
            <div className="w-full px-4 lg:w-5/12">
              <div className="hero-content">
                <span className="mb-4 block text-2xl font-medium text-primary text-orange-50">
                  반려동물 네 발자국, 우리의 두 발자국
                </span>
                <h1 className="mb-4 text-4xl  font-bold !leading-[1.208] text-white dark:text-white sm:text-[42px] lg:text-[40px] xl:text-5xl">
                  세계 최초 <br />
                  유기동물 기부 NFT 마켓
                </h1>
                <p className="mb-16 max-w-[480px] text-2xl text-[rgb(96,11,10)] dark:text-dark-6 font-semibold">
                  식스스탭은 반려동물 전주기를 관리하는 프로세스를 통해 유기동물
                  입양 문화를 장려합니다.
                </p>
                <ul className="flex flex-wrap items-center cursor-pointer">
                  <li
                    onClick={() => {
                      window.open(
                        " https://play.google.com/store/apps/details?id=com.whatcon.sixsteps&hl=ko-KR"
                      );
                    }}
                  >
                    <a className="group mr-4 inline-flex h-[70px] items-center justify-center rounded-xl bg-white py-[10px] pl-[10px] pr-5 text-center text-2xl font-semibold text-brand100  shadow-btn transition duration-200 hover:text-primary hover:shadow-lg dark:bg-dark dark:text-white">
                      <span className="mr-2 ml-1 text-dark group-hover:text-primary dark:text-dark-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="fill-current"
                        >
                          <path
                            d="M3.85245 0.375L14.0977 10.6184L16.7415 7.9746C13.1289 5.78276 8.29042 2.84244 6.11441 1.52043L4.65656 0.637253C4.3989 0.480274 4.12297 0.395734 3.85245 0.375ZM2.28856 1.60143C2.26783 1.71398 2.25 1.82709 2.25 1.94853V22.1922C2.25 22.2771 2.26708 22.3562 2.27892 22.4372L12.7016 12.0145L2.28856 1.60143ZM18.4789 9.0294L15.4938 12.0145L18.4269 14.9475C19.9809 14.0056 21.0572 13.3515 21.1767 13.2795C21.7049 12.9566 22.0032 12.4695 21.9943 11.9373C21.9864 11.415 21.688 10.9481 21.1805 10.6608C21.067 10.5956 20.0053 9.95449 18.4789 9.0294ZM14.0977 13.4106L3.88331 23.625C4.08176 23.5905 4.27995 23.5312 4.46951 23.4167C4.73216 23.2568 11.8269 18.9523 16.6894 16.0023L14.0977 13.4106Z"
                            fill=""
                          ></path>
                        </svg>
                      </span>
                      앱 다운로드 바로가기
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="hidden px-4 lg:block lg:w-1/12"></div>
            <div className="w-full px-4 lg:w-6/12">
              <div className="mx-auto text-center">
                <div className="relative z-10 mt-16 inline-block lg:mt-0">
                  <img
                    src={App_Phone_2}
                    alt="hero"
                    className="mx-auto max-w-full"
                  />
                  <div className="absolute -left-10 -top-10 z-[-1]">
                    <img
                      src="https://demo.tailgrids.com/templates/app/build/src/assets/images/hero/hero6-shape-1.svg"
                      alt="shape"
                    />
                  </div>
                  <div className="absolute -left-20 top-1/2 z-[-1]">
                    <svg
                      width="40"
                      height="38"
                      viewBox="0 0 40 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.03852 10.0507C2.56762 6.4938 5.49873 2.67846 9.31451 3.18306L32.4926 6.24813C36.3084 6.75273 38.147 11.1988 35.8021 14.2511L21.5587 32.7914C19.2138 35.8436 14.444 35.2129 12.9731 31.656L4.03852 10.0507Z"
                        stroke="#13C296"
                        stroke-width="6"
                      ></path>
                    </svg>
                  </div>
                  <div className="absolute -right-16 bottom-10 z-[-1]">
                    <svg
                      width="53"
                      height="53"
                      viewBox="0 0 53 53"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.923995 43.5761C3.73599 46.3881 7.07432 48.6187 10.7484 50.1406C14.4224 51.6624 18.3603 52.4457 22.337 52.4457C26.3138 52.4457 30.2516 51.6624 33.9257 50.1406C37.5997 48.6187 40.9381 46.3881 43.7501 43.5761C46.5621 40.7641 48.7927 37.4258 50.3145 33.7517C51.8363 30.0777 52.6196 26.1399 52.6196 22.1631C52.6196 18.1863 51.8363 14.2485 50.3145 10.5744C48.7927 6.90038 46.5621 3.56205 43.7501 0.750054L35.1655 9.3346C36.8502 11.0193 38.1865 13.0192 39.0982 15.2204C40.01 17.4215 40.4792 19.7806 40.4792 22.1631C40.4792 24.5456 40.01 26.9047 39.0982 29.1058C38.1865 31.3069 36.8502 33.3069 35.1655 34.9916C33.4808 36.6762 31.4809 38.0126 29.2797 38.9243C27.0786 39.836 24.7195 40.3053 22.337 40.3053C19.9546 40.3053 17.5954 39.836 15.3943 38.9243C13.1932 38.0126 11.1932 36.6762 9.50854 34.9916L0.923995 43.5761Z"
                        fill="#F9BA45"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* section 5 */}
      <section className="pt-20 pb-12 lg:pt-[15%] dark:bg-dark lg:pb-[30%]">
        <div className="container mx-auto">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full px-4">
              <div className="mx-auto mb-[60px] max-w-[560px] text-center">
                <h2 className="text-dark dark:text-white mb-3 text-3xl leading-[1.2] font-bold sm:text-4xl md:text-[36px]">
                  전국의 동물보호센터와 함께 합니다
                </h2>
                <span className="block mb-2 text-xl font-semibold text-primary text-brand100">
                  식스스탭에 등록된 '천 마리' 이상의 아이들이 여러분을
                  기다립니다.
                </span>
                <p className="text-xl text-body-color dark:text-dark-6 lg:mt-[20px]">
                  식스스탭은 전국에 있는 300여개의 민간동물보호센터 중 <br />
                  팅커벨 프로젝트 외 30여 기관과 함께합니다.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center -mx-4">
            <div className="w-full px-4 sm:w-4/5 md:w-1/2 lg:w-1/3">
              <div className="group relative mb-8 rounded-xl border border-stroke dark:border-dark-3 bg-white dark:bg-dark-2 p-10 text-center md:px-8 lg:py-9 lg:px-6 xl:py-[45px] xl:px-[43px]">
                <div className="relative z-10 inline-flex items-center mx-auto mb-10 h-11">
                  <span className="bg-primary absolute -right-3 top-0 z-[-1] h-[34px] w-[34px] rounded-full opacity-10"></span>
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M48.2129 27.75H46.3848C45.7676 27.75 45.2441 27.0312 45.2441 26.1875V14.375C45.2441 13.5078 45.8066 12.75 46.4473 12.75H48.2129C48.6273 12.75 49.0247 12.5853 49.3177 12.2923C49.6108 11.9993 49.7754 11.6019 49.7754 11.1875C49.7754 10.7731 49.6108 10.3756 49.3177 10.0826C49.0247 9.78958 48.6273 9.62496 48.2129 9.62496H46.4473C45.6834 9.63491 44.9363 9.85058 44.2846 10.2493C43.6329 10.648 43.1008 11.215 42.7441 11.8906H32.5176L31.0254 10.5859C29.6979 9.3961 28.1019 8.54574 26.3739 8.10763C24.6459 7.66951 22.8375 7.65669 21.1035 8.07027C16.7285 9.17964 13.8379 12.7031 12.8301 14.1562H11.2676C11.2851 12.9959 10.8506 11.8743 10.056 11.0287C9.26132 10.183 8.1689 9.6796 7.00977 9.62496H2.90039C2.48599 9.62496 2.08856 9.78958 1.79554 10.0826C1.50251 10.3756 1.33789 10.7731 1.33789 11.1875C1.33789 11.6019 1.50251 11.9993 1.79554 12.2923C2.08856 12.5853 2.48599 12.75 2.90039 12.75H6.99414C7.61133 12.75 8.13477 13.4609 8.13477 14.3125V26.1171C8.13477 26.9843 7.57227 27.75 6.93164 27.75H2.90039C2.48599 27.75 2.08856 27.9146 1.79554 28.2076C1.50251 28.5006 1.33789 28.8981 1.33789 29.3125C1.33789 29.7269 1.50251 30.1243 1.79554 30.4173C2.08856 30.7103 2.48599 30.875 2.90039 30.875H6.93164C7.69117 30.8592 8.4327 30.6409 9.07961 30.2426C9.72651 29.8443 10.2553 29.2804 10.6113 28.6093H11.1582C11.7521 28.6105 12.3357 28.7638 12.8535 29.0546C12.8139 29.2662 12.8185 29.4837 12.8669 29.6934C12.9153 29.9031 13.0065 30.1006 13.1348 30.2734L14.9395 32.6875C15.1519 32.9635 15.4479 33.1635 15.7832 33.2578L18.1738 33.8984L19.2441 36.1796C19.3399 36.3842 19.4789 36.5656 19.6516 36.7112C19.8242 36.8569 20.0264 36.9634 20.2441 37.0234L22.7598 37.7109L24.3926 40.3046C24.5986 40.6321 24.9187 40.8715 25.291 40.9765L29.6426 42.1875C29.7797 42.2275 29.9216 42.2485 30.0645 42.25C30.3204 42.2503 30.5725 42.1879 30.7986 42.068C31.0248 41.9481 31.218 41.7745 31.3613 41.5625L39.5254 29.4375C39.5971 29.3314 39.6937 29.2446 39.8067 29.1847C39.9198 29.1248 40.0459 29.0935 40.1738 29.0937H43.041C43.4169 29.6348 43.9162 30.0786 44.4977 30.3883C45.0791 30.6981 45.726 30.8649 46.3848 30.875H48.2129C48.6273 30.875 49.0247 30.7103 49.3177 30.4173C49.6108 30.1243 49.7754 29.7269 49.7754 29.3125C49.7754 28.8981 49.6108 28.5006 49.3177 28.2076C49.0247 27.9146 48.6273 27.75 48.2129 27.75ZM15.3535 15.9687C16.1895 14.789 18.4785 11.9531 21.8691 11.0937C23.1138 10.8063 24.4095 10.8238 25.646 11.1448C26.8824 11.4659 28.023 12.0808 28.9707 12.9375L32.166 15.7187C32.5549 16.0161 32.8127 16.4532 32.8848 16.9375C32.8908 17.0594 32.8718 17.1812 32.8288 17.2955C32.7857 17.4097 32.7197 17.5139 32.6348 17.6015L31.3066 19.0234C30.9691 19.3887 30.5075 19.615 30.0121 19.6584C29.5166 19.7017 29.0228 19.5589 28.627 19.2578L28.3145 19.0234C27.3474 18.2923 26.1483 17.9361 24.939 18.0209C23.7297 18.1056 22.5919 18.6255 21.7363 19.4843L14.8379 26.6171C13.7811 25.8988 12.5374 25.5051 11.2598 25.4843V17.2812H12.8223C13.318 17.2789 13.8062 17.1587 14.2463 16.9305C14.6864 16.7023 15.066 16.3726 15.3535 15.9687ZM36.9395 27.6875L29.4004 38.875L26.7129 38.0937L25.0801 35.5C24.8722 35.171 24.549 34.9314 24.1738 34.8281L21.7676 34.1718L20.6895 31.8828C20.5937 31.6782 20.4547 31.4968 20.282 31.3512C20.1094 31.2055 19.9072 31.099 19.6895 31.039L17.1191 30.3515L16.4316 29.4375L23.9473 21.625C24.2729 21.3043 24.703 21.1114 25.159 21.0813C25.615 21.0512 26.0666 21.1859 26.4316 21.4609L26.7441 21.6953C27.7581 22.4607 29.02 22.8229 30.2856 22.7118C31.5512 22.6007 32.7306 22.0241 33.5957 21.0937L34.9316 19.7343C35.3031 19.3396 35.5908 18.8738 35.7775 18.3649C35.9641 17.8561 36.0458 17.3147 36.0176 16.7734C35.9849 16.1594 35.8197 15.5597 35.5332 15.0156H42.1191V25.9531H40.1738C39.5339 25.9551 38.9042 26.1144 38.3403 26.4168C37.7763 26.7192 37.2953 27.1555 36.9395 27.6875Z"
                      fill="#E06611"
                    ></path>
                  </svg>
                </div>
                <h4 className="text-dark dark:text-white mb-[14px] text-2xl font-bold">
                  30여개의 보호센터 연계
                </h4>
                <p className="text-body-color dark:text-dark-6">
                  전국의 30여개의 동물보호센터와 협업
                  <br />
                  (2024-01-24 기준)
                </p>

                <span className="bg-primary absolute -bottom-2 left-0 right-0 z-[-1] mx-auto h-12 w-3/4 opacity-0 blur-[12px] transition group-hover:opacity-[14%]"></span>
              </div>
            </div>
            <div className="w-full px-4 sm:w-4/5 md:w-1/2 lg:w-1/3">
              <div className="group relative mb-8 rounded-xl border border-stroke dark:border-dark-3 bg-white dark:bg-dark-2 p-10 text-center md:px-8 lg:py-9 lg:px-6 xl:py-[45px] xl:px-[43px]">
                <div className="relative z-10 inline-flex items-center mx-auto mb-10 h-11">
                  <span className="bg-primary absolute -right-3 top-0 z-[-1] h-[34px] w-[34px] rounded-full opacity-10"></span>
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M48.1348 34.7656C47.1191 31.4062 43.7598 29.5312 40.5566 30.4687C37.9004 31.25 34.2285 32.3437 31.3379 33.2031C31.5723 32.2656 31.416 31.4844 31.1816 30.8594C30.4004 28.9844 28.3691 28.125 26.5723 28.125H18.6816C18.0566 28.125 17.3535 27.8125 16.6504 27.1875C15.791 26.4062 14.6191 25.9375 13.4473 25.9375H7.11914C4.30664 25.9375 1.96289 28.3594 1.96289 31.3281V41.4844C1.96289 44.5312 4.30664 46.9531 7.19727 46.9531H14.9316C15.8691 46.9531 16.8848 46.6406 17.7441 46.0938C20.0098 47.3438 22.5879 47.9688 25.166 47.9688C26.7285 47.9688 28.291 47.7344 29.6973 47.2656L43.916 42.9688H43.9941C48.291 41.3281 48.916 37.5781 48.1348 34.7656ZM7.19727 43.4375C6.25977 43.4375 5.47852 42.5781 5.47852 41.4844V31.3281C5.47852 30.3125 6.18164 29.4531 7.11914 29.4531H13.5254C13.916 29.4531 14.2285 29.6094 14.3848 29.7656C14.6191 30 14.8535 30.1562 15.0879 30.3125V43.3594C15.0098 43.3594 15.0098 43.3594 14.9316 43.3594H7.19727V43.4375ZM42.8223 39.6094L28.5254 43.9844C27.4316 44.2969 26.2598 44.5313 25.0098 44.5313C22.9785 44.5313 21.0254 43.9844 19.3066 43.0469L18.5254 42.6562V31.7187C18.6035 31.7187 18.6035 31.7187 18.6816 31.7187H26.6504C27.3535 31.7187 27.9004 32.0312 27.9785 32.2656C28.0566 32.5 27.9004 33.3594 26.2598 34.9219L25.2441 35.8594L25.9473 37.0313C26.6504 38.2813 27.3535 38.0469 30.0879 37.2656C31.3379 36.875 33.0566 36.4063 34.7754 35.9375C38.1348 34.9219 41.5723 33.9063 41.5723 33.9063C42.9004 33.5156 44.3066 34.375 44.7754 35.8594C45.166 37.1094 45.0879 38.75 42.8223 39.6094Z"
                      fill="#E06611"
                    ></path>
                    <path
                      d="M47.4316 17.6563H45.4785V3.75C45.4785 2.8125 44.6973 1.95312 43.6816 1.95312C42.666 1.95312 41.9629 2.8125 41.9629 3.75V17.6563H37.666V6.09375C37.666 5.15625 36.8848 4.29688 35.8691 4.29688C34.8535 4.29688 34.1504 5.15625 34.1504 6.09375V17.6563H29.8535V10C29.8535 9.0625 29.0723 8.20313 28.0566 8.20313C27.041 8.20313 26.2598 8.98438 26.2598 10V17.6563H25.0879C24.1504 17.6563 23.291 18.4375 23.291 19.4531C23.291 20.4688 24.0723 21.25 25.0879 21.25H47.4316C48.3691 21.25 49.2285 20.4688 49.2285 19.4531C49.2285 18.4375 48.3691 17.6563 47.4316 17.6563Z"
                      fill="#E06611"
                    ></path>
                  </svg>
                </div>
                <h4 className="text-dark dark:text-white mb-[14px] text-2xl font-bold">
                  TTA 검증 통과
                </h4>
                <p className="text-body-color dark:text-dark-6">
                  <br />
                  TTA 인증을 통과한 신뢰 기업입니다.
                </p>
                <span className="bg-primary absolute -bottom-2 left-0 right-0 z-[-1] mx-auto h-12 w-3/4 opacity-0 blur-[12px] transition group-hover:opacity-[14%]"></span>
              </div>
            </div>
            <div className="w-full px-4 sm:w-4/5 md:w-1/2 lg:w-1/3">
              <div className="group relative mb-8 rounded-xl border border-stroke dark:border-dark-3 bg-white dark:bg-dark-2 p-10 text-center md:px-8 lg:py-9 lg:px-6 xl:py-[45px] xl:px-[43px]">
                <div className="relative z-10 inline-flex items-center mx-auto mb-10 h-11">
                  <span className="bg-primary absolute -right-3 top-0 z-[-1] h-[34px] w-[34px] rounded-full opacity-10"></span>
                  <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M45.9473 17.2656H41.2598V8.125C41.2598 5.46875 39.1504 3.35938 36.4941 3.35938H10.7129C8.05664 3.35938 5.94727 5.46875 5.94727 8.125V21.7969C5.47852 22.1875 5.08789 22.7344 4.85352 23.4375L1.96289 37.5C1.80664 38.2813 2.04102 39.1406 2.58789 39.7656C3.05664 40.3906 3.83789 40.7031 4.61914 40.7031H29.7754V43.4375C29.7754 45.2344 31.2598 46.7188 33.0566 46.7188H45.9473C47.7441 46.7188 49.2285 45.2344 49.2285 43.4375V20.5469C49.2285 18.75 47.7441 17.2656 45.9473 17.2656ZM5.63477 37.1875L8.21289 24.7656H8.60352H29.8535V37.1875H5.63477ZM29.7754 20.5469V21.25H9.46289V8.125C9.46289 7.42187 10.0098 6.875 10.7129 6.875H36.4941C37.1973 6.875 37.7441 7.42187 37.7441 8.125V17.2656H33.0566C31.2598 17.2656 29.7754 18.75 29.7754 20.5469ZM45.7129 43.125H33.291V20.7812H45.7129V43.125Z"
                      fill="#E06611"
                    ></path>
                    <path
                      d="M37.7441 26.7969H41.6504C42.5879 26.7969 43.4473 26.0156 43.4473 25C43.4473 24.0625 42.666 23.2031 41.6504 23.2031H37.7441C36.8066 23.2031 35.9473 23.9844 35.9473 25C35.9473 25.9375 36.7285 26.7969 37.7441 26.7969Z"
                      fill="#E06611"
                    ></path>
                    <path
                      d="M39.541 38.9063C39.4629 38.9063 39.3066 38.9844 39.2285 38.9844C39.1504 39.0625 38.9941 39.0625 38.916 39.1406C38.8379 39.2188 38.7598 39.2969 38.6816 39.375C38.3691 39.6875 38.1348 40.1563 38.1348 40.625C38.1348 41.0938 38.291 41.5625 38.6816 41.875C38.7598 41.9531 38.8379 42.0313 38.916 42.1094C38.9941 42.1875 39.1504 42.2656 39.2285 42.2656C39.3066 42.3438 39.4629 42.3438 39.541 42.3438C39.6191 42.3438 39.7754 42.3438 39.8535 42.3438C40.3223 42.3438 40.791 42.1875 41.1035 41.7969C41.416 41.4844 41.6504 41.0156 41.6504 40.5469C41.6504 40.0781 41.4941 39.6094 41.1035 39.2969C40.7129 38.9844 40.0879 38.8281 39.541 38.9063Z"
                      fill="#E06611"
                    ></path>
                  </svg>
                </div>
                <h4 className="text-dark dark:text-white mb-[14px] text-2xl font-bold">
                  웹 &amp; 어플리케이션
                </h4>
                <p className="text-body-color dark:text-dark-6">
                  식스스탭은 웹사이트뿐와 모바일 어플리케이션
                  <br /> 서비스를 모두 제공하고 있습니다.
                </p>

                <span className="bg-primary absolute -bottom-2 left-0 right-0 z-[-1] mx-auto h-12 w-3/4 opacity-0 blur-[12px] transition group-hover:opacity-[14%]"></span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default IntroduceApp;
